import { Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, Output, ViewChild } from "@angular/core";
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from "@angular/forms";
import {MatMenuTrigger} from '@angular/material/menu';

@Component({
    selector: 'app-description',
    standalone: false,
    styles: [
      `
        /* DSM: min-height; keep a visible border (do not strip with border-none on the element) */
        textarea.input-field {
          min-height: 120px !important;
          box-sizing: border-box;
          border: 1px solid #e3e6ee !important;
          border-radius: 4px;
        }
      `,
    ],
    template: `
      <div class="relative inline-flex text-left">
        <button
          type="button"
          class="size-4 cursor-pointer"
          id="description-trigger"
          [disabled]="_disabled"
          [matMenuTriggerFor]="menu"
          #trigger="matMenuTrigger"
          (menuOpened)="onMenuOpened()"
        >
          <img
            class="h-3 w-3"
            [ngClass]="{ 'd-block': value && !hideIcon }"
            alt="note"
            src="./assets/images/icons/global/note.png"
            draggable="false"
          />
          <span class="sr-only">Open description</span>
        </button>
        <!-- Dropdown Description -->
        <mat-menu #menu="matMenu"
                  panelClass="desc-menu-panel"
                  [overlapTrigger]="false"
                  [hasBackdrop]="false"
                  class="desc-menu-panel w-72 bg-white"
                  (closed)="onMenuClosed()"
                   xPosition="before"
  yPosition="below">
        <div matMenuContent (click)="$event.stopPropagation()" aria-labelledby="description-trigger" role="dialog" class="bg-white p-3"
        >

            <label for="description" class="field-label">Description</label>
            <textarea
              id="description"
              #descInput
              [(ngModel)]="value"
              (ngModelChange)="onChange($event)"
              autocomplete="off"
              maxlength="500"
              #desc
              placeholder="Enter description [ limit: 500 characters ]"
              class="input-field !min-h-[120px] !outline-none focus:!outline-none focus:!ring-1 focus:!ring-[#E3E6EE] !resize-y !w-full text-[12px] font-normal py-2 px-4 rounded"
              rows="6"
              autofocus

            ></textarea>

        </div>
        </mat-menu>
      </div>
    `,
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DescriptionComponent),
        multi: true,
      },
    ],
  })
  export class DescriptionComponent implements ControlValueAccessor {
    @ViewChild('desc') descField?: ElementRef<HTMLTextAreaElement>;
  @ViewChild('trigger') trigger!: MatMenuTrigger;
  @ViewChild('descInput') descInput!: ElementRef<HTMLTextAreaElement>;
    onChanged: any = () => {};
    onTouched: any = () => {};
    _disabled = false;
    @Input() hideIcon = false;
    @Output() opened = new EventEmitter<void>();
    @Output() closed = new EventEmitter<void>();
    private _value: string;
    isOpen = false;
    constructor(private hostElement: ElementRef<HTMLElement>, private elementRef: ElementRef) {}
    @HostListener('document:click', ['$event'])
    handleDocumentClick(event: MouseEvent) {
      if (!this.isOpen) {
        return;
      }
      const clickTarget = event.target as Node;
      if (!this.hostElement.nativeElement.contains(clickTarget)) {
        this.close();
      }
    }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.trigger.closeMenu();
    }
  }
    public get value(): string {
      return this._value;
    }
    public set value(v: string) {
      this._value = v;
    }
    //gets the value from the formControl
    writeValue(val) {
      this.value = val;
    }
    registerOnChange(fn: any) {
      this.onChanged = fn;
    }
    registerOnTouched(fn: any) {
      this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
      this._disabled = isDisabled;
    }
    onChange(ev) {
      this.onTouched();
      this.onChanged(ev);
    }
    onMenuOpened() {
      this.isOpen = true;
      this.opened.emit();
      this.focusDescription();
    }
    onMenuClosed() {
      this.isOpen = false;
      this.closed.emit();
    }
    open() {
      if (this._disabled) {
        return;
      }
      this.isOpen = true;
      this.opened.emit();
      this.focusDescription();
    }
    close() {
      this.isOpen = false;
      this.closed.emit();
    }
    // focusDescription() {
    //   setTimeout(() => {
    //     this.descField?.nativeElement.focus();
    //   }, 100);
    // }
  focusDescription() {
    setTimeout(() => {
      this.descInput?.nativeElement?.focus();
    }, 10); // small delay ensures overlay is ready
  }
  }
